import React from 'react';
import SubBanner from '../components/SubBanner';
import AboutSection from '../components/AboutSection';
import Statistics from '../components/Statistics';
import Team from '../components/Team';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';

const AboutPage = () => {
  return (
    <>
      <SubBanner title="About Us" breadcrumb="About" />
      <AboutSection />
      <Statistics />
      <Team />
      <Testimonials />
      <CallToAction />
    </>
  );
};

export default AboutPage;